export enum RetailMatchDynamicTextEnum {
  NotSimilar = "NOT SIMILAR",
  SomewhatSimilar = "SOMEWHAT SIMILAR",
  Similar = "SIMILAR",
  VerySimilar = "VERY SIMILAR",
  Low = "LOW",
  SlightlyLower = "SLIGHTLY LOWER",
  BelowAverage = "BELOW AVERAGE",
  Comparable = "COMPARABLE",
  Average = "AVERAGE",
  High = "HIGH",
  Outperforms = "OUTPERFORMS",
}
